export default __webpack_public_path__ + "static/media/checkmark-icon.4995b537.svg";